export default async function request(url, body) {
  // The try / catch is needed in case the request fails at the network level.
  try {
    // Make the request. Our API is POST-only and JSON-only. If there isn't any body,
    // don't send the Content-Type header.
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    })

    // Parse the response JSON. This can also throw an error if the response data is
    // invalid JSON, which it shouldn't be. (The API normalizes all responses to be in
    // JSON format.)
    const resObj = await res.json()

    // If in development, log the request for debugging.
    if (process.env.NODE_ENV === 'development') {
      if (resObj.success) {
        console.log(`Request: ${url}`, resObj)
      } else {
        console.error(`Request: ${url}`, resObj)
      }
    }
    
    // Return the entire response. Any data sent back should be on resObj.data.
    return resObj
  } catch (err) {
    // If in development, log the error that was thrown.
    if (process.env.NODE_ENV === 'development') {
      console.error(`Request: ${url}`, err)
    }
    
    // Return a generic response object that indicates the error was network-level
    // (probably).
    return {
      success: false,
      error: 'FailedRequest',
      message: 'check your internet connection',
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js